import _asyncToGenerator from "/home/runner/work/mainrepo/mainrepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { MediaAssetProviderCloudinary } from '@common/cloudinary/shared';
import { AppRequestService } from '@core/frontend-shared';
import { CloudinarySelectFromHostComponent } from './select-from-host.component';
import { CloudinaryTransformationsComponent } from './transformations.component';
import { GetMediaAssetDetailsByUrlRequest, GetMediaAssetDetailsRequest } from '@common/media/shared';
import { firstValueFrom, map } from 'rxjs';
export class MediaAssetProviderCloudinaryFrontend extends MediaAssetProviderCloudinary {
  initialize() {
    super.initialize();
    this.api = this.injector.get(AppRequestService);
  }
  getAssetDetails(_x) {
    var _this = this;
    return _asyncToGenerator(function* (asset, config = {}) {
      return firstValueFrom(_this.api.sendRequest(GetMediaAssetDetailsRequest, {
        assetId: asset.id,
        ...config
      }).pipe(map(response => response.details)));
    }).apply(this, arguments);
  }
  getAssetDetailsByUrl(_x2) {
    var _this2 = this;
    return _asyncToGenerator(function* (url, config = {}) {
      return firstValueFrom(_this2.api.sendRequest(GetMediaAssetDetailsByUrlRequest, {
        url,
        ...config
      }).pipe(map(response => response.details)));
    }).apply(this, arguments);
  }
  // TODO: MPF-152 - common lib must not contain app-specific data. Provide via configuration
  getUploadPathSuggestions() {
    return _asyncToGenerator(function* () {
      return Promise.resolve(['/', '/meinpflegeforum', '/meinpflegeforum/certificates', '/meinpflegeforum/courses']);
    })();
  }
  selectFromHost_getComponent() {
    return CloudinarySelectFromHostComponent;
  }
  transformationManager_getComponent() {
    return CloudinaryTransformationsComponent;
  }
}